// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const TABLE_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY = {
  VIRTUAL_MEASURES_SUMMARIZED_COLUMN_INDEX: 'table.columns.measuresSummarized.index',
  SHOW_GRAND_TOTAL_FOR_COLUMNS: 'table.showGrandTotalForColumns.enabled',
  SHOW_GRAND_TOTAL_FOR_ROWS: 'table.showGrandTotalForRows.enabled',
  SHOW_ROW_NUMBERS: 'table.rowNumbers.enabled',
  USE_DISTINCT: 'table.distinct.enabled',
  FROZEN_COLUMNS: 'table.frozenColumns',
  AGGREGATE_FUNCTION_DISPLAY: 'table.aggregateFunctionDisplay',
  PIVOT_TABLE_MAX_MEASURES: 'table.pivot.maxMeasures',
  PIVOT_TABLE_MAX_COLUMN_DIMENSIONS: 'table.pivot.maxColumnDimensions',
  PIVOT_TABLE_MAX_ROW_DIMENSIONS: 'table.pivot.maxRowDimensions',
  TABLE_MAX_MEASURES: 'table.nonPivot.maxMeasures',
  TABLE_MAX_ROW_DIMENSIONS: 'table.nonPivot.maxRowDimensions',
  TABLE_QUICK_EDIT_MODE: 'table.quickEditMode',
  PAGINATION: 'table.pagination.enabled',
  PAGINATION_PAGE_SIZE: 'table.pagination.pageSize',
  FORMAT_TEMPLATE_ID: 'table.formatTemplate.id',
  FORMAT_TEMPLATE_NAME: 'table.formatTemplate.name',
  ADHOC_REPORT_TEMPLATE_ITEM_NAME: 'table.adhocReportLayout.itemName',
  ADHOC_REPORT_TEMPLATE_REPOSITORY_NAME: 'table.adhocReportLayout.repositoryName'
} as const;

/** @see net/disy/cadenza/workbook/model/TableDataViewSettingsKey.java */
export type TableDataViewSettingsKey = keyof typeof TABLE_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY;

export const TableDataViewSettingsKey = {
  values: Object.keys(TABLE_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY) as readonly TableDataViewSettingsKey[],
  toPersistenceKey: (value: TableDataViewSettingsKey) => TABLE_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY[value],
  fromPersistenceKey: (persistenceKey: string) => {
    const value = TableDataViewSettingsKey.values.find(key => TABLE_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY[key] === persistenceKey);
    if (!value) { throw new Error(`No TableDataViewSettingsKey for key: ${persistenceKey}`); }
    return value;
  },
} as const;

// </GENERATED-CODE>
